package com.dotpx.ambient

data class AmbienceMorphStatus(
    val isMorphing: Boolean,
    val activeScene: AmbienceScene,
    val activeSeed: ULong,
    val activeMatchesPresetCombination: Boolean,
    val targetScene: AmbienceScene?,
    val targetSeed: ULong?,
    val remainingFrames: Long,
    val consumedCommandGeneration: Long = 0,
    val completedCommandGeneration: Long = 0,
)
